
import React, { Suspense } from 'react';
// import Suspanse from './../Suspense/Suspense'
import { RouteConfig } from './../jsMethods'
import routers from './../routesConfig'


function MainLayout(props) {

    return (
        <div>
            <Suspense fallback={<div>Loading...</div>}>
                <RouteConfig  routers={routers} />
            </Suspense>
        </div>
    )
}


export default React.memo(MainLayout);
